/* eslint-disable react-hooks/exhaustive-deps */
import {FC, useContext, useMemo} from 'react'
import {useQuery} from 'react-query'
import {QUERIES, WithChildren} from '../../../../../_dashboard/helpers'
import {useQueryRequest} from './QueryRequestProvider'
import {getAll} from '../../../../services/common_requests'
import {
  createReservationResponseContext,
  Reservation,
  initialReservationQueryResponse,
} from './_models'
import {buildReservationApiQuery} from './reservationListQuery'

const QueryReservationResponseContext = createReservationResponseContext<Reservation>(
  initialReservationQueryResponse,
)
const QueryResponseProvider: FC<WithChildren> = ({children}) => {
  const {state} = useQueryRequest()
  const apiQuery = useMemo(() => buildReservationApiQuery(state), [state])

  const {
    isFetching: isFetchingReservations,
    refetch: refetchData,
    data: dataResponse,
  } = useQuery(
    [QUERIES.RESERVATIONS_LIST, apiQuery],
    () => getAll(apiQuery, '/reservations'),
    {cacheTime: 0, keepPreviousData: true, refetchOnWindowFocus: false},
  )

  return (
    <QueryReservationResponseContext.Provider
      value={{
        isLoading: isFetchingReservations,
        refetchData,
        dataResponse,
        query: apiQuery,
      }}
    >
      {children}
    </QueryReservationResponseContext.Provider>
  )
}

const useQueryResponse = () => useContext(QueryReservationResponseContext)

const useQueryResponseData = () => {
  const {dataResponse} = useQueryResponse()
  if (!dataResponse) {
    return []
  }
  return dataResponse.data
}

const useQueryResponseLoading = (): boolean => {
  const {isLoading} = useQueryResponse()
  return isLoading
}

export {
  QueryResponseProvider,
  useQueryResponse,
  useQueryResponseData,
  useQueryResponseLoading,
}
